"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETypeCards = void 0;
var ETypeCards;
(function (ETypeCards) {
    ETypeCards["QUESTION"] = "QUESTION";
    ETypeCards["PLAISIR"] = "PLEASURE";
    ETypeCards["EVENT"] = "EVENT";
})(ETypeCards = exports.ETypeCards || (exports.ETypeCards = {}));
